/**
 * useScrollLock — Bloque le scroll du body quand un overlay est ouvert.
 *
 * §11/§18 DA — hook a11y réutilisable pour modals, drawers.
 * Câblé dans ModalShell.
 * Restaure l'overflow d'origine au démontage (pas de side-effect persistant).
 *
 * @param {boolean} active — activer/désactiver le lock
 *
 * @example
 *   useScrollLock(isOpen);
 */
import { useEffect } from 'react';

export function useScrollLock(active) {
  useEffect(() => {
    if (!active) return;

    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = prev;
    };
  }, [active]);
}
